import '../Style/Contact.css'
import call from '../Images/call.png'
import ContactForm from './Email';
import { FaFacebook,  FaWhatsapp } from 'react-icons/fa';
import { CgWebsite } from 'react-icons/cg';
function Contact() {
    return (
        <>
            <div className="container-fluid contact row pb-5 d-flex justify-content-center align-items-center m-0 ">
                <div className=" text-center col-lg-8 mb-4">
                        <h1 className="display-2 fw-bold">Contact Us</h1>
                    <p className="fw-bold">"I am the designer of this website, which showcases examples of front-end interfaces. For inquiries or collaboration opportunities, please choose your preferred method of contact."</p>
                </div>    


                    <div className='row mt-5'>
                        <div className='col-lg-6 '><ContactForm/></div>
                        <img src={call} alt='' className='col-lg-6 m-auto' style={{width:"40%",height:"auto"}} />
                </div> 
               <div className='row text-center d-flex justify-content-center gap-3 mt-4' >
    <div className='col-lg-2  link-div p-3'>
        <a href='https://facebook.com/ramiibra7im' target='_blank' rel='noopener noreferrer' style={{ color: 'inherit', textDecoration: 'none' }}>
            <FaFacebook className='display-2 link' />
            <h3>Facebook</h3>
        </a>
    </div>
    <div className='col-lg-2 link-div p-3'>
        <a href='https://wa.me/201551212431' target='_blank' rel='noopener noreferrer'  style={{ color: 'inherit', textDecoration: 'none' }}>
            <FaWhatsapp className='display-2 link' />
            <h3 >Whatsapp </h3>
        </a>
    </div>
    <div className='col-lg-2 link-div p-3'>
        <a href='https://rb-ramy.vercel.app' target='_blank' rel='noopener noreferrer' style={{ color: 'inherit', textDecoration: 'none' }}>
            <CgWebsite className='display-2 link'/>
            <h3>Website</h3>
        </a>
    </div>
</div>

            </div>    
        </>
    )
}
export default Contact;